import type { HTMLAttributes } from 'react'
import { cn } from '~/lib/utils'

// 펄스 플레이스홀더 블록 — 로딩 중 콘텐츠 자리를 잡는다. 시맨틱 토큰만, 다크 자동 적응.
/** 미니멀 스켈레톤. width/height는 className(예: h-4 w-32)으로 지정한다. */
export function Skeleton({
    className,
    ...props
}: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            data-slot='skeleton'
            aria-hidden='true'
            className={cn(
                'bg-secondary h-4 w-full animate-pulse rounded-[var(--radius-sm)]',
                className
            )}
            {...props}
        />
    )
}
